module.exports = {
  src: __webpack_public_path__ + "static/media/families_00016.c34d8eb5.jpg",
  width: 4200,
  height: 3300,
  bytes: 757620,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/families_00016.c34d8eb5.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/families/families_00016.jpg
// module id = 391
// module chunks = 0